export const costs = [
  'Spiegare giacimenti, perforazione e raffinazione senza materiali visivi chiari è difficile',
  'I libri di testo sono troppo tecnici oppure troppo superficiali',
  'Perdi ore a cercare schemi e dati affidabili su internet',
  'Gli studenti non collegano il petrolio alla vita quotidiana: carburanti, plastica, energia',
  'È difficile trattare in modo equilibrato ambiente e transizione energetica',
];
